import React, { Component } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";

import "./autocomplete.css";

class AutoComplete extends Component {
  render() {
    const {
      label,
      list,
      id,
      style,
      onChange,
      defaultValue,
      multiple,
      size,
    } = this.props;
    return (
      <Autocomplete
        id={id}
        className="autocomplete-box autoCompleteDropdown"
        options={list}
        autoSelect={true}
        // defaultValue={defaultValue}
        value={defaultValue}
        getOptionLabel={(option) => option.name || ""}
        style={style}
        onChange={(event, value) => onChange(value)}
        multiple={multiple}
        size={size}
        renderInput={(params) => (
          <TextField
            {...params}
            label={label}
            variant="outlined"
            size={size}
            margin="normal"
            fullWidth
          />
        )}
        classes={{
          popper: "autocompletePopper",
        }}
      />
    );
  }
}

export default AutoComplete;
